import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import { ResourceType } from '@dealstack/shared/lib/common/fineGrainedAuthorization/permissions';
import { BasicUserWithPermissionsRes, PermissionRole } from '@dealstack/shared/lib/generated';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';

export const getUserForDeal = async (userId: string, dealId: string) => {
	const response = await makeRequest<{
		payload: BasicUserWithPermissionsRes;
	}>({
		endpoint: formatUnicorn(API_PATHS.DEAL_DEALID_USERS_USERID_GET, {
			dealId,
			userId,
		}),
		method: HTTP_METHOD.GET,
	});
	return response;
};

export const addDealPermissionToUser = async ({
	dealId,
	userId,
	permissionRoles,
}: {
	dealId: string;
	userId: string;
	permissionRoles: PermissionRole[];
}) => {
	return makeRequest<void>({
		endpoint: formatUnicorn(
			API_PATHS.PERMISSIONS_RESOURCETYPE_RESOURCEID_PERMISSIONS_CREATE_POST,
			{
				resourceType: ResourceType.DEAL,
				resourceId: dealId,
			}
		),
		method: HTTP_METHOD.POST,
		body: JSON.stringify({
			userId,
			permissionRoles,
		}),
	});
};

export const removeDealPermissionFromUser = async ({
	dealId,
	userId,
	permissionRoles,
}: {
	dealId: string;
	userId: string;
	permissionRoles: PermissionRole[];
}) => {
	return makeRequest<void>({
		endpoint: formatUnicorn(
			API_PATHS.PERMISSIONS_RESOURCETYPE_RESOURCEID_PERMISSIONS_DELETE_POST,
			{
				resourceType: ResourceType.DEAL,
				resourceId: dealId,
			}
		),
		method: HTTP_METHOD.POST,
		body: JSON.stringify({
			userId,
			permissionRoles,
		}),
	});
};

export const syncUserInDealToAllProgrammes = async ({
	dealId,
	userId,
}: {
	dealId: string;
	userId: string;
}) => {
	return makeRequest<void>({
		endpoint: formatUnicorn(API_PATHS.DEAL_DEALID_USERS_USERID_SYNC_POST, {
			dealId,
			userId,
		}),
		method: HTTP_METHOD.POST,
	});
};
